import React, { useState } from 'react';
import LocalizedMessage from 'react-l10n';
import ReactLoading from 'react-loading';
import { axiosUpdateCustomers } from '../../actions/customerActions';
import { handleAxiosErrors } from '../../_utils';
import useManualReactTableState from '../ManualReactTableState';
import { getTranslation } from '../../lang/main';
import {
    createModal,
    hideModal,
} from '../../dom/components/confirm-removal-modal';

function MyStoreReviewCustomer(props) {
    const { customerID } = props;
    const identifier = customerID;
    const mrtState = useManualReactTableState({});

    const { isUserInputLoading, toggleUserInputLoading } = mrtState;

    // Request
    const handleApprovalClick = (e, identifier, approvalStatus) => {
        const loadingKey = 'ApprovalStatus';

        toggleUserInputLoading(identifier, loadingKey, true);

        const approvalOrder = () => {
            return axiosUpdateCustomers(identifier, true)
                .then((response) => {
                    window.location.href = `${
                        window.baseURL
                    }my-store/customers/`;
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    toggleUserInputLoading(identifier, loadingKey, false);
                });
        };

        const rejectOrder = () => {
            return axiosUpdateCustomers(identifier, false)
                .then((response) => {
                    window.location.href = `${
                        window.baseURL
                    }my-store/customers/`;
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    toggleUserInputLoading(identifier, loadingKey, false);
                });
        };

        // Declined
        if (!approvalStatus) {
            const modalName = 'confirm-reject-order-modal';
            const data = {
                heading: getTranslation(
                    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_HEADING'
                ),
                noticeText: getTranslation(
                    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONTENT'
                ),
                confirm: getTranslation(
                    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONFIRM'
                ),
            };

            createModal(
                modalName,
                data,
                () => {
                    toggleUserInputLoading(identifier, loadingKey, true);
                    hideModal(modalName);
                    rejectOrder();
                },
                () => {
                    hideModal(modalName);
                }
            );

            toggleUserInputLoading(identifier, loadingKey, false);
        } else {
            // Approval
            approvalOrder();
        }
    };

    const renderLoading = () => {
        return (
            <div
                style={{
                    position: 'relative',
                    height: 35,
                    width: '100%',
                }}
            >
                <ReactLoading
                    type='spin'
                    className='button__spinner'
                    color='black'
                    height={20}
                    width={20}
                />
            </div>
        );
    };

    const renderOrderButtons = () => {
        return (
            <span
                className='react-table__info'
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type='button'
                    className='button button--less-fat button--green button--uppercase'
                    onClick={(e) => handleApprovalClick(e, identifier, true)}
                >
                    <>
                        <span className='icon icon-check-thick' />
                        <span>
                            <LocalizedMessage id={'Approval'} />
                        </span>
                    </>
                </button>
                <button
                    type='button'
                    className='button button--less-fat button--red button--uppercase'
                    onClick={(e) => handleApprovalClick(e, identifier, false)}
                >
                    <>
                        <span className='icon icon icon-close-thick' />
                        <span>
                            <LocalizedMessage id={'Reject'} />
                        </span>
                    </>
                </button>
            </span>
        );
    };

    return (
        <>
            {isUserInputLoading(identifier, 'ApprovalStatus')
                ? renderLoading()
                : renderOrderButtons()}
        </>
    );
}

export default MyStoreReviewCustomer;
